// replace Unicode dashes with ASCII minus and parse
export const parseCoord = (v: unknown): number | null => {
  if (typeof v === 'number' && Number.isFinite(v)) return v
  if (typeof v !== 'string') return null

  const cleaned = v
    .trim()
    .replace(/[\u2212\u2012\u2013\u2014]/g, '-') // minus, figure, en, em
    .replace(/,/g, '.')                          // decimal commas to dot
    .replace(/[^0-9.+-]/g, '')                   // keep digits, dot, plus, minus

  const n = parseFloat(cleaned)
  return Number.isFinite(n) ? n : null
}

export const normLng = (lng: number): number => {
  return ((lng + 180) % 360 + 360) % 360 - 180
}
